import { REACT_APP_VMS_BASE_URL } from "../utils/urls";

const fetchDateVisitsPrevIn = async (
  site_id: any,
  startDate: any,
  endDate: any
) => {
  const result = await fetch(
    `${REACT_APP_VMS_BASE_URL}/visits/sites/${site_id}/prev/in?start=${startDate}&end=${endDate}`
  );
  const visits = await result.json();
  return visits;
};

export default fetchDateVisitsPrevIn;
